import { useFormikContext } from 'formik';
import { useEffect } from 'react';

/**
 * This component is used to trigger a side effect when the form values change.
 * @param {function} onChange - A callback function that is called with the current form values whenever they change.
 * @returns {null} - This component does not render anything to the DOM as it's just used as a listener for side effects.
 */
const FormikEffect = ({ onChange }) => {
  const { values } = useFormikContext();

  useEffect(() => {
    onChange(values);
  }, [onChange, values]);

  return null;
};

export default FormikEffect;
